import { Component, OnInit } from '@angular/core';
import { EmailData, EmailService } from '../email.service';
import { UtilitieService } from 'src/app/services/utils/utilities.service';

@Component({
  selector: 'contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.css']
})
export class ContactComponent implements OnInit {

  contact: EmailData = {
    name: '',
    email: '',
    subject: '',
    message: ''
  };

  submitted = false;

  constructor(private emailService: EmailService, private utilService: UtilitieService) { }

  // Simulate form submission
  onSubmit(): void {
    this.emailService.sendEmail(this.contact).then((response) => {

      this.submitted = true;

      // Here you could call a service to handle the form submission (e.g., send email)
      // this.contactService.sendContactMessage(this.contact).subscribe(...);

      // Reset form
      this.contact = {
        name: '',
        email: '',
        subject: '',
        message: ''
      };
    });

  }



  ngOnInit(): void {

    this.utilService.updateLoading(true);
  }

}
